import React from 'react';
import LogoWebnets from '../../assets/images/logo-webnets.png';
import { Assinatura, Footer } from './AppFooterEstilo';

const AppFooter = () => (
  <Footer>
    <Assinatura>
      <p>Criado por</p>
      <img src={LogoWebnets} alt="Logo da WebNets" />
    </Assinatura>
  </Footer>
);

export default AppFooter;
